export default "__VITE_ASSET__W2rpd2zj__"